
import type { PropType } from 'vue'
import type { ColorEnum } from '../enums'
import { defineComponent } from 'vue'
import { UiTooltip } from './keen-ui'

export default defineComponent({
  name: 'EpbLegend',
  components: {
    UiTooltip,
  },
  props: {
    items: {
      type: Array as PropType<
        Array<{
          label: string
          icon?: string
          color?: ColorEnum
          description?: string
        }>
      >,
      required: true,
    },
    showLabels: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      baseClass: 'epb-legend',
    }
  },
})
